module.exports = __webpack_public_path__ + "img/1-3.1627c7be.png";